import _ from 'lodash'
import moment from 'moment'

export function simulateLCRPData (activity) {
  // Store sample data in a new property and initialize
  activity.tmpSampleData = {}
  activity.tmpSampleData.score = _.cloneDeep(activity.score)

  activity.tmpSampleData.studentData = {}
  activity.tmpSampleData.studentData.user_rights === '3_instructor'
  activity.tmpSampleData.studentData.user_id_array = [
    'samplestudent1@gmail.com',
    'samplestudent2@gmail.com',
    'samplestudent3@gmail.com',
    'samplestudent4@gmail.com',
    'samplestudent5@gmail.com',
    'samplestudent6@gmail.com',
    'samplestudent7@gmail.com',
    'samplestudent8@gmail.com',
    'samplestudent9@gmail.com'
  ]
  activity.tmpSampleData.studentData.user_firstName_array = [
    'Louis',
    'Adam',
    'Marie',
    'Ada',
    'Ralph',
    'Albert',
    'Nikola',
    'Isaac',
    'Stephen'
  ]
  activity.tmpSampleData.studentData.user_lastName_array = [
    'Pasteur',
    'Smith',
    'Curie',
    'Lovelace',
    'Emerson',
    'Einstein',
    'Tesla',
    'Newton',
    'Hawking'
  ]

  activity.tmpSampleData.studentData.participating_students = 9
  activity.tmpSampleData.studentData.started_students = 9
  activity.tmpSampleData.studentData.completed_students = 0
  activity.tmpSampleData.studentData.completed_timestamp_array = [null, null, null, null, null, null, null, null, null]
  activity.tmpSampleData.studentData.user_grade_array = [0, 0, 0, 0, 0, 0, 0, 0, 0]
  activity.tmpSampleData.studentData.user_questions_received = [0, 0, 0, 0, 0, 0, 0, 0, 0]
  activity.tmpSampleData.studentData.user_activity_scores = [0, 0, 0, 0, 0, 0, 0, 0, 0]
  activity.tmpSampleData.studentData.user_rights_array = []

  activity.courseAvgTime = activity.allTopics.reduce((a) => a + 11 + _.random(0, 2), 0)
  activity.tmpSampleData.studentData.time_on_task_array = _.shuffle([
    activity.courseAvgTime * 0.6 * 60,
    activity.courseAvgTime * 0.7 * 60,
    activity.courseAvgTime * 0.8 * 60,
    activity.courseAvgTime * 0.9 * 60,
    activity.courseAvgTime * 1.0 * 60,
    activity.courseAvgTime * 1.1 * 60,
    activity.courseAvgTime * 1.2 * 60,
    activity.courseAvgTime * 1.3 * 60,
    activity.courseAvgTime * 1.4 * 60,
  ])

  activity.tmpSampleData.students = [{}, {}, {}, {}, {}, {}, {}, {}, {}]
  activity.tmpSampleData.rosterData = [{}, {}, {}, {}, {}, {}, {}, {}, {}]
  activity.tmpSampleData.courseRosterData = {}

  activity.tmpSampleData.allTopics = _.cloneDeep(activity.allTopics)

  _.each(activity.tmpSampleData.allTopics, (topic) => {
    topic.pe_arr = [0, 0, 0, 0, 0, 0, 0, 0, 0]
    topic.pa_arr = [0, 0, 0, 0, 0, 0, 0, 0, 0]
    topic.class_questions_received = 0
    topic.class_points_available = 0
    topic.class_points_earned = 0

    let sum_scores = 0

    _.each(activity.tmpSampleData.studentData.user_id_array, (student, index) => {
      topic.pa_arr[index] = _.round(activity.tmpSampleData.score.scoreTarget / activity.tmpSampleData.allTopics.length)
      topic.pe_arr[index] = _.random(_.round(topic.pa_arr[index] * 0.45), topic.pa_arr[index])

      const question_count = 4 + _.random(0, 2)

      topic.class_questions_received += question_count
      topic.class_points_available += topic.pa_arr[index]
      topic.class_points_earned += topic.pe_arr[index]

      activity.tmpSampleData.studentData.user_questions_received[index] += question_count
      activity.tmpSampleData.studentData.user_activity_scores[index] += (topic.pe_arr[index] + _.random(0, topic.pa_arr[index]))
      activity.tmpSampleData.studentData.user_rights_array[index] = '1_student'

      sum_scores += Math.round(100 * topic.pe_arr[index] / topic.pa_arr[index])
    })
  })

  activity.tmpSampleData.topics = _.cloneDeep(activity.tmpSampleData.allTopics)

  // build activity.students array
  // _.times invokes a function n times and returns an array of each function's return value
  activity.tmpSampleData.students = _.map(activity.tmpSampleData.studentData.user_id_array, (id, index) => {

    let grade = 0
    let completed = false
    if (activity.tmpSampleData.studentData.user_activity_scores[index] >= activity.tmpSampleData.score.scoreTarget) {
      activity.tmpSampleData.studentData.completed_students++
      completed = true
      grade = 100
    }
    activity.tmpSampleData.studentData.user_grade_array[index] = grade

    const tp = activity.tmpSampleData.topics.map((topic, i, a) => {
      return {
        qr: _.round(activity.tmpSampleData.studentData.user_questions_received[index] / a.length),
        pe: topic.pe_arr[index],
        pa: topic.pa_arr[index],
        nl: topic.nextLevel
      }
    })

    const completedTimestamp = completed ? moment.utc().subtract(_.random(1, 5 * 24, true), 'hours').toDate() : null
    const startedTimestamp = (completed ? moment.utc(completedTimestamp) : moment.utc()).subtract(_.random(1, 5 * 24, true), 'hours').toDate()

    let returnObj = {
      id: id,
      firstName: activity.tmpSampleData.studentData.user_firstName_array[index],
      lastName: activity.tmpSampleData.studentData.user_lastName_array[index],
      questionsReceived: activity.tmpSampleData.studentData.user_questions_received[index],
      score: activity.tmpSampleData.studentData.user_activity_scores[index],
      completion: activity.tmpSampleData.studentData.user_activity_scores[index],
      grade: activity.tmpSampleData.studentData.user_grade_array[index],
      startedTimestamp,
      completedTimestamp,
      dueDate: '',
      index: index.toString(),
      timeOnTask: activity.tmpSampleData.studentData.time_on_task_array[index],
      activity_state: {
        qr: activity.tmpSampleData.studentData.user_questions_received[index],
        score: activity.tmpSampleData.studentData.user_activity_scores[index],
        target: activity.tmpSampleData.score.scoreTarget,
        tp: tp,
        quizTimes: [
          {
            startQuizTime: 1527905053000,
            completeQuizTime: _.random(
              (1527905053000 + (activity.tmpSampleData.studentData.user_questions_received[index] * 30000)),
              (1527905053000 + (activity.tmpSampleData.studentData.user_questions_received[index] * 60000))
            )
          },
          {
            startQuizTime: 1527905053000,
            completeQuizTime: _.random(
              (1527905053000 + (activity.tmpSampleData.studentData.user_questions_received[index] * 30000)),
              (1527905053000 + (activity.tmpSampleData.studentData.user_questions_received[index] * 60000))
            )
          },
          {
            startQuizTime: 1527905053000,
            completeQuizTime: _.random(
              (1527905053000 + (activity.tmpSampleData.studentData.user_questions_received[index] * 30000)),
              (1527905053000 + (activity.tmpSampleData.studentData.user_questions_received[index] * 60000))
            )
          }
        ],
        last_question_end: 1527905109207,
        total_question_time: 52435,
        total_questions_completed: activity.tmpSampleData.studentData.user_questions_received[index],
        hintCount: _.random(0,4),
        completedQuestionCount: Math.max(0, activity.tmpSampleData.studentData.user_questions_received[index] - _.random(0, 2)),
      },
      lcrp_progress: {
        ra: []
      }
    }

    return grade === 100 ? buildRetakeObjects(returnObj, activity.tmpSampleData, index) : returnObj
  })
  let rosterData = _.map(activity.tmpSampleData.students, (student, index) => {
    return {
      user_id: student.id,
      activity_state: JSON.stringify(student.activity_state),
      first_accessed_date: '2018-06-02 02:04:12',
      last_accessed_date: '2018-06-0' + _.random(1, 8) + '02:05:09',
      activity_title: 'Sample Read & Practice Activity 1',
      activity_file: activity.config.file,
      course_id: 'TestCourse',
      assignment_id: activity.config.itemId,
      first_name: student.firstName,
      last_name: student.lastName,
      email: student.id,
      lcrp_progress: JSON.stringify(student.lcrp_progress),
      index: index
    }
  })

  let courseAssignments = _.map(activity.tmpSampleData.students, (student, index) => {
    let randomAssignment = _.random(1, 4);
    let activity_title, activity_file, assignment_id
    switch(randomAssignment) {
      case 1:
        activity_title = 'Sample Read & Practice Activity 2'
        activity_file = 'fixtures-vitalsource-psych'
        assignment_id = 'fake_psych_duck'
        break
      case 2:
        activity_title = 'Sample Read & Practice Activity 3'
        activity_file = 'psych/SchacterBrief3e/schacterbrief3e_ch11_personality'
        assignment_id = 'fake_SchacterBrief3e'
        break
      case 3:
        activity_title = 'Sample Read & Practice Activity 4'
        activity_file = 'Cowen_Micro_3e/cowen3e_micro_ch01'
        assignment_id = 'fake_Cowen_Micro'
        break
      case 4:
        activity_title = 'Sample Read & Practice Activity 5'
        activity_file = 'Lunsford_Generic/Topics_Main_Ideas'
        assignment_id = 'fake_Lunsford_Generic'
        break
      default:
        activity_title = 'Sample Read & Practice Activity 6'
        activity_file = 'fixtures-vitalsource-chucknorris'
        assignment_id = 'fake_chuck_norris'
    }

    return {
      user_id: student.id,
      activity_state: JSON.stringify(student.activity_state),
      first_accessed_date: '2018-05-02 02:04:12',
      last_accessed_date: '2018-05-0' + _.random(1, 8) + '02:05:09',
      activity_title: activity_title,
      activity_file: activity_file,
      course_id: 'TestCourse',
      assignment_id: assignment_id,
      first_name: student.firstName,
      last_name: student.lastName,
      email: student.id,
      lcrp_progress: JSON.stringify(student.lcrp_progress),
      index: index
    }
  })
  activity.tmpSampleData.rosterData = rosterData.concat(courseAssignments)

  return activity
}

export function simulateLCRPTopicalPerformance (assignmentOverview) {
  const topicTitles = [
    'Sample Topic 1',
    'Sample Topic 2',
    'Sample Topic 3',
    'Sample Topic 4',
  ]

  const assignments = _.cloneDeep(assignmentOverview)
  _.each(assignments, (assignment, idx) => {
    const { avgFirst } = assignment
    const numOfTopics = _.random(2, 4)

    const topicsWithoutQuestions = _.random(0, 1)
    const topicsWithQuestions = numOfTopics - topicsWithoutQuestions
    let availablePoints = topicsWithQuestions * avgFirst

    const scores = []
    for (let i = 0; i < topicsWithQuestions; i++) {
      const bottom = avgFirst - 10 > 0 ? avgFirst - 10 : 0
      const top = avgFirst + 10 < 100 ? avgFirst + 10 : 100
      let score = _.random(bottom, top)
      if (score > availablePoints || i === topicsWithQuestions.length - 1) {
        score = availablePoints
      }

      if (avgFirst === null) {
        scores.push(0)
        continue
      }

      scores.push(score)
      availablePoints -= score
    }

    if (topicsWithoutQuestions) {
      scores.unshift(0)
    }

    const topicalPerformances = {}
    for (let j = 0; j < scores.length; j++) {
      let hasQuestions = scores[j] > 0
      if (avgFirst === null) {
        hasQuestions = true
      }

      topicalPerformances[topicTitles[j]] = {
        hasQuestions,
        score: scores[j]
      }
    }

    assignments[idx].topicalPerformance = topicalPerformances
  })

  return assignments
}

function buildRetakeObjects (returnObj, activity, index) {
  const {scoreTarget} = activity.score
  const qr = activity.topics.length * (4 + _.random(0, 2))
  returnObj.activity_state.rt = {
    qr: qr,
    target: scoreTarget,
    score: _.random(_.round(scoreTarget * 0.50), _.round(scoreTarget * 1.25)),
    tp: buildRetakeTopics(activity, qr),
    hintCount: _.random(0, 2),
    quizTimes: [
      {
        startQuizTime: 1527905053000,
        completeQuizTime: _.random(
          (1527905053000 + (activity.studentData.user_questions_received[index] * 30000)),
          (1527905053000 + (activity.studentData.user_questions_received[index] * 60000))
        )
      },
      {
        startQuizTime: 1527905053000,
        completeQuizTime: _.random(
          (1527905053000 + (activity.studentData.user_questions_received[index] * 30000)),
          (1527905053000 + (activity.studentData.user_questions_received[index] * 60000))
        )
      },
      {
        startQuizTime: 1527905053000,
        completeQuizTime: _.random(
          (1527905053000 + (activity.studentData.user_questions_received[index] * 30000)),
          (1527905053000 + (activity.studentData.user_questions_received[index] * 60000))
        )
      }
    ]
  }
  // build multiple retake objects
  while (_.random(1)) {
    returnObj.lcrp_progress.ra.push({
      target: activity.score.scoreTarget,
      score: _.random(activity.score.scoreTarget, activity.score.scoreTarget + 25),
      tp: buildRetakeTopics(activity)
    })
  }
  return returnObj
}

function buildRetakeTopics (activity, qr = _.random(1, activity.topics.length * 10)) {
  let points = 0
  return activity.topics.map((topic, i, a) => {
    const upperBound = _.round(activity.score.scoreTarget / 3)
    const lowerBound = _.round(upperBound * 0.70)
    if (i !== a.length - 1) {
      points = _.round(qr / activity.topics.length)
      qr -= points
    }
    return {
      pa: upperBound,
      pe: _.random(lowerBound, upperBound),
      qr: i !== a.length - 1 ? points : qr
    }
  })
}
